import { render, staticRenderFns } from "./strategyComment.vue?vue&type=template&id=6f3bc954&scoped=true&"
import script from "./strategyComment.vue?vue&type=script&lang=js&"
export * from "./strategyComment.vue?vue&type=script&lang=js&"
import style0 from "./strategyComment.vue?vue&type=style&index=0&id=6f3bc954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3bc954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3bc954')) {
      api.createRecord('6f3bc954', component.options)
    } else {
      api.reload('6f3bc954', component.options)
    }
    module.hot.accept("./strategyComment.vue?vue&type=template&id=6f3bc954&scoped=true&", function () {
      api.rerender('6f3bc954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/strategyComment.vue"
export default component.exports